var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pa-4 d-flex justify-space-between align-center"},[_c('div',[_c('Breadcrumbs',{attrs:{"headline":"Thời Khóa Biểu","link":[{ text: 'Thời khóa biểu', href: '../teachingTimeTable' }]}})],1)]),_c('v-card',{staticClass:"mx-4 py-1 full-width full-height"},[_c('TeacherTimeTable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }